<template>
    <component :is="tag" v-bind="$attrs" v-if="active">
        <slot />
    </component>
    <slot v-bind="$attrs" v-else />
</template>
  
<script setup>
const props = defineProps({
    tag: String,
    active: Boolean
})

</script>